import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/img/avatar2.png'


const _hoisted_1 = { class: "container-fluid container-app-config" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  class: "profile-img-2"
}
const _hoisted_5 = { class: "row mt-1" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "spn-name" }
const _hoisted_8 = { class: "row mt-3" }
const _hoisted_9 = { class: "form-group col-12 control-container-2" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = { class: "row mt-2" }
const _hoisted_12 = { class: "form-group col-12 control-container" }
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = { class: "form-label" }
const _hoisted_15 = {
  for: "chkTogleTheme1",
  class: "switch-label"
}
const _hoisted_16 = { class: "row mt-5" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "centerButton" }

import { PropType, ref, onMounted } from 'vue';
import { ISesionApp } from '@/core/model/sesion/ISesionApp';
import Dropdown from 'primevue/dropdown';
import {languagesLst} from '@/i18n';
import AppSystemSettingsService, { IAppUserSettings } from '@/core/services/sys/AppSystemSettingsService';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import {  eThemesNames } from '@/core/model/GloblasEnum';
import Button from 'primevue/button';
import SelectImage from './SelectImage.vue';
import { IsMimeImageValid, traduceTexto } from '@/core/services/base/GlobalFunctios';
import AppUIManagerService from '@/core/services/AppUIManagerService';
import { FileUp } from '@/core/model/IFileData';
import Image from 'primevue/image';
import LoginService from '@/core/services/login/LoginService';
import { useI18n } from 'vue-i18n';
import moment from 'moment';
import { usePrimeVue } from 'primevue/config';
import jsonLangEsDefault from '@/locales/es.json';
import jsonLangEnDefault from '@/locales/en.json';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileConfigView',
  props: {
    sesion: { type: Object as PropType<ISesionApp>, required:true }
},
  emits: ['onSave'],
  setup(__props, { emit: __emit }) {

const uiManager:AppUIManagerService = useServicesFactoryStore().getAppUIManagerService;
const appSettingsService:AppSystemSettingsService = useServicesFactoryStore().getAppSystemSettingsService
const loginService:LoginService = useServicesFactoryStore().getLoginService;
const currentLang = useI18n();
const primevue = usePrimeVue();
//const settingTheme:IAppSystemSettings = appSettingsService.getSettingByName(eSettingsNames.theme);
//const settingLanguage:IAppSystemSettings = appSettingsService.getSettingByName(eSettingsNames.language);

const imgAvatar = ref<any>(null);
let userTheme = ref<string>('');
let idioma = ref<any>(null);
const props = __props;
const emits = __emit;
const labels={
    imgNoValid :traduceTexto('globals.ImagenNoValida')
}
const changeTheme = ()=>
{
  const activeTheme = userTheme.value.split('_')[0].toLowerCase();    
  if (activeTheme === "light" || !activeTheme)       
    userTheme.value = eThemesNames.dark;      
  else 
    userTheme.value = '';   
}
const toggleTheme = () =>
{  
  const activeTheme = userTheme.value.split('_')[0].toLowerCase();    
  if (activeTheme === "light" || !activeTheme)
  {     
    setTheme('');//(eThemesNames.light); 
    primevue.changeTheme('lara-dark-blue','lara-light-blue', 'site-theme-link');    

  }
  else 
  {
    setTheme(eThemesNames.dark);
    primevue.changeTheme('lara-light-blue','lara-dark-blue', 'site-theme-link');    
  }
}

const setTheme = (theme:string) =>
{
/*https://medium.com/@dgongoragamboa/añadir-darkmode-a-un-proyecto-de-vue-3679af55b642 */
 // userTheme.value = theme;
  //document.documentElement.className = theme;
  document.documentElement.setAttribute('data-theme', theme);
  //localStorage.setItem("user-theme", theme);  
  //console.log(document.documentElement);
  //document.documentElement.className = theme;
}
const onSetFoto = (foto: any) =>
{
    if (foto)
    {
      const valid = IsMimeImageValid(foto.type);
      if (!valid)
      {
        uiManager.showError(labels.imgNoValid);
      }
      else
      {
        const reader = new FileReader();
        reader.onload = (e: any) =>
        {                          
          AddGaleria(foto, e.target.result);
        };
        reader.readAsDataURL(foto);                    
      }
    }
}
const AddGaleria = (foto: FileUp, img: string) =>
{
  imgAvatar.value =
  {        
    name: foto.name,
    img: img
  };    
}
const SaveAppOptions = async()=>
{
  const sesion:ISesionApp = await loginService.getSession();
  const settings:IAppUserSettings = {
    profileImg:imgAvatar.value && imgAvatar.value.img? imgAvatar.value.img.split(',')[1]:null,
    theme:userTheme.value,
    language:idioma.value.id
  };
  uiManager.loadingUi();  
  await appSettingsService.SaveAppOptions(sesion.Employee?.User.Gid, settings);
  await loginService.SaveAppSettings(settings);
  uiManager.loadingUi();  
  changeLanguage();
  toggleTheme();
  emits('onSave',settings); 
}

const changeLanguage = ()=>
{  
  //$i18n.locale = idioma.id;
  currentLang.locale.value = idioma.value.id;
  moment.locale(idioma.value.id);  
  switch(idioma.value.id)
  {
    case 'es-mx':
      primevue.config.locale = {...jsonLangEsDefault.prime};
      break;
    case 'en-us': 
      primevue.config.locale = {...jsonLangEnDefault.prime};
      break;
  }  
}
onMounted(async ()=>
{               
  const appSettings = await loginService.getAppSettings();            
  imgAvatar.value ={img: appSettings.profileImg? 'data:image/png;base64,' +  appSettings.profileImg:null};
  idioma.value = languagesLst.find((x:any)=>x.id === appSettings.language);
  userTheme.value = props.sesion.Employee?.User.Theme? appSettings.theme:'';  
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SelectImage, {
          edicion: true,
          onOnSetFile: onSetFoto
        }, {
          default: _withCtx(() => [
            ( imgAvatar.value && imgAvatar.value.img)
              ? (_openBlock(), _createBlock(_unref(Image), {
                  key: 0,
                  src: imgAvatar.value.img,
                  width: "100",
                  height: "100",
                  class: "profile-img-2b"
                }, null, 8, ["src"]))
              : (_openBlock(), _createElementBlock("img", _hoisted_4))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.sesion.FullName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('AppConfig.Lang')), 1),
        _createVNode(_unref(Dropdown), {
          modelValue: _unref(idioma),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(idioma) ? (idioma).value = $event : idioma = $event)),
          options: _unref(languagesLst),
          optionLabel: "title",
          class: "w-100 vb-control vb-control-dropdown"
        }, {
          value: _withCtx((slotProps) => [
            (slotProps.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(`languageIco ${slotProps.value.logo}`)
                }, [
                  _createElementVNode("span", null, _toDisplayString(slotProps.value.title), 1)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          option: _withCtx((slotProps) => [
            _createElementVNode("div", {
              class: _normalizeClass(`languageIco ${slotProps.option.logo}`)
            }, [
              _createElementVNode("span", null, _toDisplayString(slotProps.option.title), 1)
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('AppConfig.Tema')), 1),
          _createElementVNode("input", {
            id: "chkTogleTheme1",
            type: "checkbox",
            class: "switch-checkbox",
            onChange: changeTheme
          }, null, 32),
          _createElementVNode("label", _hoisted_15, [
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "🌙", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "☀️", -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["switch-toggle", { 'switch-toggle-checked': _unref(userTheme) === 'dark_Default' }])
            }, null, 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(Button), {
            type: "button",
            onClick: SaveAppOptions
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('globals.aceptar')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})